import { CallbackWrap } from '@/types/common'
import { faChevronDown, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import React, { ReactNode } from 'react'

type ContextType = [
  string | undefined,
  (value: CallbackWrap<string | undefined>) => void
]

const SidebarContext = React.createContext<ContextType>(undefined!)

export function PassiveSidebar({
  className,
  title,
  children
}: {
  className: string
  title: string
  children: ReactNode
}) {
  const [expandedClass, setExpanded] = React.useContext(SidebarContext)
  const onToggle = React.useCallback(
    () => setExpanded((e) => (e === className ? undefined : className)),
    [className, setExpanded]
  )

  const expanded = expandedClass === className
  const hidden = expandedClass && expandedClass !== className

  return (
    <div
      className={classNames('poe-sidebar', className, {
        'poe-expanded': expanded,
        'poe-hidden': hidden
      })}
      onClick={expanded ? undefined : onToggle}>
      <div className="poe-header" onClick={expanded ? onToggle : undefined}>
        {title}
        <FontAwesomeIcon
          className="poe-chevron"
          icon={expanded ? faChevronLeft : faChevronDown}
        />
      </div>
      <div className="poe-content">{children}</div>
    </div>
  )
}

export function PassiveSidebarContainer({
  initialState,
  children
}: {
  initialState?: string
  children: ReactNode
}) {
  const [expanded, setExpanded] = React.useState(initialState)
  const contextValue = React.useMemo<ContextType>(
    () => [expanded, setExpanded],
    [expanded]
  )
  return (
    <SidebarContext.Provider value={contextValue}>
      {children}
    </SidebarContext.Provider>
  )
}
